export default __webpack_public_path__ + "static/media/small.d02fd5f0.jpg";